import React from "react";
import "./PdfContent.scss";
import { useParams } from 'react-router-dom';

const PrivacyPolicyContent = () => {
  let tag = {
    62580:{appName:"62580",companyName:"强生致行互联网科技（上海）有限公司"},
    ddcx:{appName:"叮叮出行",companyName:"重庆庞大叮叮科技有限公司南京分公司"},
    ydyc:{appName:"悦道用车",companyName:"上海美跃信息技术有限公司"},
    qxcx:{appName:"前行出行",companyName:"前行无限(天津)科技有限公司"},
    tgcx:{appName:"同港出行",companyName:"重庆渐臻科技有限公司"},
  }
  const params = useParams();
  const routeTag = params.tag;
  let currentTag = routeTag || "62580";
  let appName = tag[currentTag].appName;
  let companyName = tag[currentTag].companyName;
  
  return (
    <div className="pdf-container">
      <div className="pdf-content">
        <h1 className="title">{appName}隐私政策</h1>
        
        <p className="pdf-paragraph">
          本隐私政策（以下称"本政策"）所称"{appName}平台"是指由{companyName}（以下简称"我们"）及其现有和/或未来设立的相关关联公司所运营的主要面向乘客用户的平台，包括但不限于我们及关联公司所开发的官网、客户端（{appName}APP）、微信公众号、小程序等。
        </p>

        <p className="pdf-paragraph">
          {appName}平台非常重视对您的个人信息和隐私保护，我们将按照本政策收集、使用、存储、委托处理、对外提供和保护您的个人信息。在您使用{appName}平台的产品及服务前，请您仔细阅读并全面了解本政策，以便作出适当的选择。如果您是未成年人，您的监护人需要仔细阅读本政策并同意您依照本政策使用我们的产品及服务。
        </p>

        <p className="pdf-paragraph">
          我们收集、使用、存储、委托处理、对外提供和保护您的个人信息，是在遵守国家法律法规规定的前提下，出于向您提供{appName}平台中的产品及服务，并不断提升产品及服务质量以及安全性的目的，包括但不限于支持我们开展{appName}平台中产品及服务相关的市场活动、完善现有产品及服务功能、开发新产品或新服务。
        </p>

        <h1 className="pdf-main-title">本政策主要包括以下内容：</h1>
        
        <h2 className="pdf-clause-title">1. 本政策的适用范围</h2>
        <h2 className="pdf-clause-title">2. 个人信息的定义与范围</h2>
        <h2 className="pdf-clause-title">3. 个人信息的收集和使用</h2>
        <h2 className="pdf-clause-title">4. 我们如何使用Cookie和同类技术</h2>
        <h2 className="pdf-clause-title">5. 个人信息的对外提供、公开披露与委托处理</h2>
        <h2 className="pdf-clause-title">6. 个人信息的存储与保护</h2>
        <h2 className="pdf-clause-title">7. 用户权利</h2>
        <h2 className="pdf-clause-title">8. 未成年人保护</h2>
        <h2 className="pdf-clause-title">9. 修订及更新</h2>
        <h2 className="pdf-clause-title">10. 如何联系我们</h2>
        <h2 className="pdf-clause-title">11. 我们的基本情况</h2>

        <h1 className="pdf-main-title">1. 本政策的适用范围</h1>
        
        <p className="pdf-paragraph">
          本政策适用于{appName}平台提供的所有服务，您访问{appName}平台或登录相关客户端使用{appName}提供的服务，均适用于本政策。但如{appName}平台部分产品或服务单独设置了隐私条款/隐私政策的，单独的隐私条款/隐私政策优先适用，单独的隐私条款/隐私政策未提及的内容，适用本政策。
        </p>
        
        <p className="pdf-paragraph">
          本政策不适用于通过{appName}平台接入的其他第三方服务所收集的信息，其他第三方可能有自己的隐私协议/隐私政策。当您查看其他第三方创建的网页或使用其他第三方开发的应用程序时，可能会发现第三方在该网页或应用程序放置的Cookie或像素标签，这些Cookie或标签不受我们的控制，而且它们的使用不受本政策的约束。我们对您在第三方使用的个人信息的行为及后果不承担任何责任。
        </p>

        <h1 className="pdf-main-title">2. 个人信息的定义及范围</h1>
        
        <h2 className="pdf-clause-title">
          2.1 本政策所指的个人信息包含个人信息以及敏感个人信息。个人信息是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息。敏感个人信息是指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息。
        </h2>
        
        <h2 className="pdf-clause-title">
          2.2 匿名化处理后的信息，即通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后不能被复原的信息，不属于个人信息。
        </h2>
        
        <h2 className="pdf-clause-title">
          2.3 其他无法识别特定自然人身份或者反映特定自然人活动情况的信息不属于个人信息。
        </h2>

        <h1 className="pdf-main-title">3. 个人信息的收集和使用</h1>
        
        <p className="pdf-paragraph">
          3.1 {appName}APP属于"网络约车类"APP，{appName}APP及平台的基本功能为"网络预约出租汽车服务、巡游出租汽车电召服务"，必要个人信息为：注册用户移动电话号码，乘车人出发地、到达地、位置信息、行踪轨迹以及支付时间、支付金额、支付渠道等支付信息。如果您拒绝{appName}平台获取您的必要个人信息，{appName}平台可能无法为您提供前述对应的基本功能。
        </p>
        
        <p className="pdf-paragraph">
          3.2 我们仅会出于本政策所述的以下目的，收集和使用您的个人信息，以便为您提供对应功能或服务：
        </p>

        <h2 className="pdf-clause-title">3.2.1 用户注册、登录及认证</h2>
        
        <p className="pdf-paragraph">
          （1）为了遵守法律法规的要求，以及向您提供我们的产品与服务，我们需要识别您的身份，当您注册我们的账号及您在使用我们的相关服务时，您需要向我们提供您的手机号码，并通过短信验证码进行验证登录。如果您拒绝提供手机号码，我们将无法为您创建账号并提供服务。
        </p>
        
        <p className="pdf-paragraph">
          （2）您可以选择向我们提供您的性别、年龄、姓名、行业信息，我们收集这类信息是基于您的同意，以协助您完善您的个人资料。如您拒绝提供上述信息，不会影响您使用我们的基本功能。
        </p>
        
        <p className="pdf-paragraph">
          （3）您可以选择向我们提供常用地址（包括家的地址及公司地址）。设置常用地址后，您可以更便捷地填入行程起始终点信息，我们收集这类信息是基于您的同意，以提高服务效率。
        </p>

        <h2 className="pdf-clause-title">3.2.2 网约车服务</h2>
        
        <p className="pdf-paragraph">
          （1）位置信息。为了便于您不需要手动输入当前位置即可获得推荐的上车地点、行程起点、向您展示附近车源情况、为您提供行程路径规划导航，我们会收集您的位置信息。
        </p>
        
        <p className="pdf-paragraph">
          （2）行程信息及订单信息。当您作为乘客下单呼叫车辆、预约行程时，您需提供出发地、到达地、用车时间及备注信息（选填），以便我们匹配符合您需求的车辆、司机。
        </p>

        <h2 className="pdf-clause-title">3.2.3 支付结算及发票开具</h2>
        
        <p className="pdf-paragraph">
          您在{appName}平台进行交易支付时（包括余额充值），如果使用第三方支付功能，我们需获取您的支付时间、支付金额、支付渠道、支付工具及订单信息、订单支付状态、充值信息、余额、优惠券信息。
        </p>

        <h1 className="pdf-main-title">4. 我们如何使用Cookie和同类技术</h1>
        
        <p className="pdf-paragraph">
          Cookie是支持服务器端（或者脚本）在客户端上存储和检索信息的一种机制。当您使用{appName}平台的产品或服务时，为使您获得更轻松安全的访问体验，我们可能会使用Cookie或同类技术来收集和存储信息，目的是为了简化您重复登录的步骤、了解您的偏好、进行数据分析、提升改善产品服务及优化用户体验。
        </p>

        <h1 className="pdf-main-title">5. 个人信息的对外提供、公开披露与委托处理</h1>
        
        <p className="pdf-paragraph">
          5.1 我们不会对外提供、共享您的个人信息，但以下情形除外：
        </p>
        
        <h2 className="pdf-clause-title">
          （1）获得您的明确同意后，我们会向第三方提供您的个人信息；
        </h2>
        
        <h2 className="pdf-clause-title">
          （2）根据法律法规规定、诉讼、争议解决的需要，或按行政、司法机关依法提出的要求，以及其他法定义务履行的必需，对外提供您的信息；
        </h2>
        
        <h2 className="pdf-clause-title">
          （3）共享给关联公司：{appName}平台内的部分服务可能是我们的关联公司向您提供，因此我们可能将您的个人信息共享给我们的关联公司。
        </h2>

        <h1 className="pdf-main-title">6. 个人信息的存储与保护</h1>
        
        <p className="pdf-paragraph">
          6.1 原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。如我们需向境外传输个人信息，我们将遵循相关国家规定并取得您的单独同意。
        </p>
        
        <p className="pdf-paragraph">
          6.2 为保障您的信息安全，我们努力采取各种符合业界标准的安全措施来保护您的个人信息，建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。
        </p>

        <h1 className="pdf-main-title">7. 用户权利</h1>
        
        <p className="pdf-paragraph">
          在您使用我们的服务期间，您可以通过相应页面提示或本政策载明的方式联系我们，以查询、复制、转移、拒绝或更正、补充、删除您的个人信息，以及行使改变授权同意的范围与注销账号的权利。
        </p>
        
        <h2 className="pdf-clause-title">7.1 查询、复制、转移个人信息</h2>
        <h2 className="pdf-clause-title">7.2 更正、补充个人信息</h2>
        <h2 className="pdf-clause-title">7.3 删除个人信息</h2>
        <h2 className="pdf-clause-title">7.4 改变您的同意范围</h2>
        <h2 className="pdf-clause-title">7.5 注销账号</h2>

        <h1 className="pdf-main-title">8. 未成年人保护</h1>
        
        <p className="pdf-paragraph">
          8.1 {appName}平台非常重视对未成年人信息的保护。如果您是未满18周岁的未成年人，在您使用我们的服务前应事先征得您的监护人同意。同时，您和您的监护人需要仔细阅读本政策并同意依照本政策使用{appName}平台。
        </p>
        
        <p className="pdf-paragraph">
          8.2 如果您是14周岁以下的儿童用户，在您使用我们的服务前应事先征得您的监护人同意。您和您的监护人需要仔细阅读本政策和《{appName}儿童个人信息隐私政策》，确保在取得监护人对本政策和《{appName}儿童个人信息隐私政策》的同意后，您才可在监护人的指导下使用我们的服务。
        </p>

        <h1 className="pdf-main-title">9. 修订与更新</h1>
        
        <p className="pdf-paragraph">
          我们将根据法律法规的最新要求对本政策进行修订更新。本政策修订更新后，我们会在{appName}平台发布最新版本，并通过弹窗、平台公示、页面提示、推送通知等方式依法征得您的同意。
        </p>
        
        <p className="pdf-paragraph">
          如果您不同意我们修订更新的内容，请您立刻停止使用{appName}平台及相关服务。
        </p>

        <h1 className="pdf-main-title">10. 如何联系我们</h1>
        
        <p className="pdf-paragraph">
          如您对本政策或您个人信息的相关事宜有任何问题、意见或建议，请联系我们的客服团队。我们将在15天内或法律规定的期限内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，且在您反馈后我们仍拒绝改进的，您还可以向有管辖权的法院提起诉讼来寻求解决方案。
        </p>

        <h1 className="pdf-main-title">11. 我们的基本情况</h1>
        
        <p className="pdf-paragraph">
          公司名称：{companyName}
        </p>
        
        <p className="pdf-paragraph">
          本隐私政策更新日期：【2024】年【04】月【22】日
        </p>
        <p className="pdf-paragraph">
          本隐私政策生效日期：【2024】年【04】月【29】日
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicyContent;
